<template>
  <element-list :prevRoute="prevRoute" :latest="latest" :admin="admin" />
</template>

<script>
import ElementList from "@/components/ElementList";

export default {
  props: ["latest", "admin"],
  components: {
    ElementList
  },
  data: () => ({
    prevRoute: ""
  }),
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.hash;
    });
  }
};
</script>